import { hashSeed, mix32, nextState } from './rng';

export const SEED_ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'; // Crockford Base32
export const SEED_LENGTH = 8;

/** 대문자화 → 하이픈·공백 제거 → I,L→1 / O→0. 절단하지 않는다. */
export function normalizeSeed(raw: string): string {
  const up = raw.toUpperCase().replace(/[^0-9A-Z]/g, '');
  return up.replace(/[IL]/g, '1').replace(/O/g, '0');
}

export function isValidSeed(raw: string): boolean {
  const s = normalizeSeed(raw);
  if (s.length !== SEED_LENGTH) return false;
  for (let i = 0; i < s.length; i++) {
    if (SEED_ALPHABET.indexOf(s.charAt(i)) < 0) return false;
  }
  return true;
}

/** 표시용. A7K20128 → A7K2-0128. 호출 전에 isValidSeed 를 통과시킨다. */
export function formatSeed(seed: string): string {
  return `${seed.slice(0, 4)}-${seed.slice(4)}`;
}

/**
 * 세션 시드 + 판 번호 → 판 시드. 로그에 (sessionSeed, runIndex) 두 값만 남기면 복원된다.
 *
 * 글자마다 상태를 다시 섞고 **상위 5비트**를 쓴다.
 * 2^32 LCG 의 하위 k비트는 주기가 2^k 라 `h % 32` 로 뽑으면 8글자 전체가 초기 하위 5비트 하나로
 * 결정되어 출력이 32종으로 접힌다(실측: 100만 호출에서 서로 다른 출력 32개).
 */
export function deriveRunSeed(sessionSeed: string, runIndex: number): string {
  let s = hashSeed(normalizeSeed(sessionSeed), `run#${runIndex}`);
  let out = '';
  for (let i = 0; i < SEED_LENGTH; i++) {
    s = nextState(s);
    out += SEED_ALPHABET.charAt(mix32(s) >>> 27);
  }
  return out;
}
